import React, { useMemo } from 'react'
import { InstantSearch, Configure, connectAutoComplete } from 'react-instantsearch-dom'
import { getAlgoliaClient } from '../../services/search/algoliaClientFactory'
import { UserSearchContext } from '../../services/search/UserSearchContext'

// Bridges connectAutoComplete state into UserSearchContext so RepoInvitationModal
// can be decoupled from react-instantsearch-dom.
const UserSearchBridge = connectAutoComplete(({
  // eslint-disable-next-line react/prop-types
  hits: suggestions, refine, currentRefinement, children,
}) => {
  const value = useMemo(
    () => ({ suggestions, refine, currentRefinement }),
    [suggestions, refine, currentRefinement],
  )
  return (
    <UserSearchContext.Provider value={value}>
      {children}
    </UserSearchContext.Provider>
  )
})

/**
 * Standalone search provider for user/contact lookup (Repo Invitation modal).
 *
 * This is a separate provider from SearchProviderContainer — it operates on a
 * different Algolia index ('users') and serves an unrelated domain. Swapping
 * the user search engine requires editing only this file.
 *
 * Props:
 *   searchKey {string}      Algolia search-only API key.
 *   children  {ReactNode}   Rendered inside UserSearchContext.Provider.
 */
function UserSearchProviderContainer({ searchKey, children }) {
  if (!searchKey) return null

  const searchClient = getAlgoliaClient(
    process.env.REACT_APP_PLICKERS_ALGOLIA_APP_ID,
    searchKey,
  )

  return (
    <InstantSearch searchClient={searchClient} indexName='users'>
      <Configure hitsPerPage={6} />
      <UserSearchBridge>
        {children}
      </UserSearchBridge>
    </InstantSearch>
  )
}

export default UserSearchProviderContainer
